module.exports = __webpack_public_path__ + "img/por_entregar.47170ea1.png";